import { useSelector, shallowEqual } from 'react-redux';
import { selectCreditValue } from 'state/order-credit/order-summary-slice';
import { PARTNERS } from 'config/app-config';
import { usePartner } from 'components/app/routes/usePartner';

export const useCreditValue = () => {
  const creditValue = useSelector(selectCreditValue, shallowEqual);
  const { activePartner } = usePartner();
  const isVoiceSalesWinbackJourney = activePartner[PARTNERS.VOICESALES_WINBACK];
  return isVoiceSalesWinbackJourney ? { voiceSaleCredit: creditValue } : {};
};
